import { gql } from "@apollo/client";

export const categoriesGql = gql`
  query Categories {
    categories {
      data {
        id
        attributes {
          name
          rank
          slug
          image {
            data {
              id
              attributes {
                name
                url
                formats
              }
            }
          }
        }
      }
    }
  }
`;

export const getCategoryDetails = gql`
  query getCategoryDetails($slug: String!) {
    categories(filters: { slug: { eq: $slug } }) {
      data {
        id
        attributes {
          slug
          meta
          meta_ar
        }
      }
    }
  }
`;

export const getSubCategories = gql`
  query SubCategories {
    subCategories {
      data {
        attributes {
          name
        }
      }
    }
  }
`;
